class EnquiryForm extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector("dialog");
    this.form = this.querySelector("form");
    this.errorContainer = this.querySelector("[data-errors]");

    this.querySelectorAll("[data-modal-close]")?.forEach((el) => {
      el.addEventListener("click", () => this.close());
    });

    this.dialog.addEventListener("click", (e) => {
      if (e.target === this.dialog) this.close();
    });

    document
      .querySelector("[data-enquiry-trigger]")
      ?.addEventListener("click", () => this.open());

    this.form?.addEventListener("submit", (e) => this.handleSubmit(e));

    if (this.querySelector("[data-success-message]")) {
      this.open();
    }

    if (this.querySelector("template[data-row-template]")) {
      this._initRows();
    }

    if (this.querySelector("[data-quantity-input]")) {
      this._initQuantity();
    }
  }

  open() {
    this.dialog.showModal();
  }

  close() {
    this.dialog.close();
  }

  handleSubmit(e) {
    this.clearErrors();
    if (!this.validate()) {
      e.preventDefault();
    }
  }

  validate() {
    const fields = this.form.querySelectorAll("input, textarea, select");
    const empty = Array.from(fields).find(
      (el) => el.required && el.value.trim() === "",
    );
    if (empty) {
      this.showError("Fields marked with * are required");
      return false;
    }
    return true;
  }

  showError(message) {
    if (!this.errorContainer) return;
    this.errorContainer.removeAttribute("hidden");
    this.errorContainer.innerHTML = `<p class="copy-sm-medium">${message}</p>`;
  }

  clearErrors() {
    if (!this.errorContainer) return;
    this.errorContainer.setAttribute("hidden", "");
    this.errorContainer.innerHTML = "";
  }

  // --- Rows behaviour (gallery rail, wall shelving, protective strip) ---

  _initRows() {
    this.rowTemplate = this.querySelector("template[data-row-template]");
    this.rowsContainer = this.querySelector("[data-rows-container]");

    this.querySelector("[data-add-row]")?.addEventListener("click", () =>
      this._addRow(),
    );

    this.rowsContainer.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-remove-row]");
      if (btn) this._removeRow(btn.closest("[data-row]"));
    });

    this._refreshRemoveButtons();
  }

  _rowCount() {
    return this.rowsContainer.querySelectorAll("[data-row]").length;
  }

  _addRow() {
    const index = this._rowCount();
    const clone = this.rowTemplate.content.cloneNode(true);

    clone.querySelectorAll("[name]").forEach((el) => {
      el.name = el.name.replace(/__INDEX__/g, index + 1);
    });
    clone.querySelectorAll("[id]").forEach((el) => {
      el.id = el.id.replace(/__INDEX__/g, index + 1);
    });
    clone.querySelectorAll("[for]").forEach((el) => {
      el.htmlFor = el.htmlFor.replace(/__INDEX__/g, index + 1);
    });

    this.rowsContainer.appendChild(clone);
    this._refreshRemoveButtons();
  }

  _removeRow(row) {
    if (this._rowCount() <= 1) return;
    row.remove();
    this._reindexRows();
    this._refreshRemoveButtons();
  }

  _reindexRows() {
    this.rowsContainer.querySelectorAll("[data-row]").forEach((row, i) => {
      row.querySelectorAll("[name]").forEach((el) => {
        el.name = el.name.replace(/_\d+\]/, `_${i + 1}]`);
      });
      row.querySelectorAll("[id]").forEach((el) => {
        el.id = el.id.replace(/_\d+$/, `_${i + 1}`);
      });
      row.querySelectorAll("[for]").forEach((el) => {
        el.htmlFor = el.htmlFor.replace(/_\d+$/, `_${i + 1}`);
      });
    });
  }

  _refreshRemoveButtons() {
    const count = this._rowCount();
    this.rowsContainer.querySelectorAll("[data-remove-row]").forEach((btn) => {
      btn.disabled = count <= 1;
    });
  }

  // --- Quantity behaviour (cremone bolt) ---

  _initQuantity() {
    this.quantityInput = this.querySelector("[data-quantity-input]");
    this.boltsContainer = this.querySelector("[data-bolts-container]");
    this.boltTemplate = this.querySelector("template[data-bolt-template]");

    this.quantityInput.addEventListener("input", () => {
      const n = Math.max(1, parseInt(this.quantityInput.value) || 1);
      this._syncBoltRows(n);
    });

    this.boltsContainer.addEventListener("change", (e) => {
      if (!e.target.matches("input[type='checkbox']")) return;
      const sameAsAbove = e.target.closest("[data-same-as-above]");
      if (!sameAsAbove) return;
      const fieldsDiv = sameAsAbove.nextElementSibling;
      if (fieldsDiv) fieldsDiv.hidden = e.target.checked;
    });
  }

  _syncBoltRows(n) {
    const current = this.boltsContainer.querySelectorAll("[data-bolt]").length;

    if (n > current) {
      for (let i = current; i < n; i++) {
        this._addBoltRow(i);
      }
    } else {
      const bolts = this.boltsContainer.querySelectorAll("[data-bolt]");
      for (let i = current - 1; i >= n; i--) {
        bolts[i].remove();
      }
    }
  }

  _addBoltRow(index) {
    const clone = this.boltTemplate.content.cloneNode(true);

    clone.querySelectorAll("[name]").forEach((el) => {
      el.name = el.name.replace(/__INDEX__/g, index + 1);
    });
    clone.querySelectorAll("[id]").forEach((el) => {
      el.id = el.id.replace(/__INDEX__/g, index + 1);
    });
    clone.querySelectorAll("[for]").forEach((el) => {
      el.htmlFor = el.htmlFor.replace(/__INDEX__/g, index + 1);
    });
    clone.querySelectorAll(".bolt-number").forEach((el) => {
      el.textContent = index + 1;
    });

    const boltEl = clone.querySelector("[data-bolt]");
    if (boltEl) {
      boltEl.dataset.boltIndex = index;

      const sameAsAboveSection = boltEl.querySelector("[data-same-as-above]");
      if (sameAsAboveSection) {
        sameAsAboveSection.hidden = index === 0;
      }
    }

    this.boltsContainer.appendChild(clone);
  }
}

customElements.define("enquiry-form", EnquiryForm);
